@if (placeholder) {
  <div class="toolbox-component dark" id="image">
    <div class="header">
      <div class="header-title">
        <span class="header-title-main">
          {{ 'i18n.toolbox.image.title' | translate }}
        </span>
      </div>
      <mat-icon svgIcon="close"
        class="close-x"
      (click)="btnCancelClick()"></mat-icon>
    </div>
    <div class="content">
      <image-cropper></image-cropper>
      <div class="controls">
        <image-zoom></image-zoom>
        <image-rotate></image-rotate>
        <image-quality-rating #imageQualityRating class="img-toolbox">
        </image-quality-rating>
      </div>
      <button class="primary" (click)="btnOKClick()">
        <mat-icon svgIcon="crop"></mat-icon>
        {{ 'i18n.button.cropImage' | translate }}
      </button>
    </div>
  </div>
}
